import { Flex } from "@chakra-ui/react";
import { TotalDurationRadialChart } from "../../dashboard/charts/v2/TotalDurationRadialChart";
import BasePageTitleContainer from "../../form/BasePageTitleContainer";

interface metric {
  totalDuration: number;
  averageDuration: number;
}

export const TotalDurationCard = ({
  metric,
  runCount,
}: {
  metric: metric;
  runCount: number;
}) => {
  return (
    <BasePageTitleContainer
      height="168px"
      mt="0px"
      padding="24px"
      maxWidth="100%"
      mx="0px"
    >
      <Flex flexDir="column" justifyContent="center" alignItems="center">
        <div>
          <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
            Total duration — Last {runCount} attempts
          </p>
        </div>
        <TotalDurationRadialChart data={metric} />
      </Flex>
    </BasePageTitleContainer>
  );
};
